import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_DE_UQ || "uq.de.styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_DE_UQ || "uqde-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_DE_UQ || 24166,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_DE_UQ || 24168,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_DE_UQ ||
    "1:160978693362:web:69912a36226563c047346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-83CRD0G2RC" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.DE, LANGUAGE.EN],
  countryRegion: "Europe/Berlin",
  timeZone: {
    [LANGUAGE.DE]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2,
        MEZ: 1,
        MESZ: 2
      }
    },
    [LANGUAGE.EN]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    }
  },
  timeZoneParentCategory: {
    MEZ: "CET",
    MESZ: "CEST"
  },
  dateFormat: {
    [LANGUAGE.DE]: "<dd>.<mm>.<yyyy>",
    [LANGUAGE.EN]: "<dd>.<mm>.<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.DE]: "<dd>.<mm>",
    [LANGUAGE.EN]: "<dd>.<mm>"
  },
  requireDecimal: true,
  memberPricingEnabled: true
};

export default _countryEnv;
